import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Breadcrumbs component with structured data for SEO
 * @param {Array} items - Array of {name, url} objects
 */
const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  // Build BreadcrumbList schema
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.name,
      "item": `https://feelingfroggy.llc${item.url}`
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="breadcrumb-nav mb-3">
        <ol className="breadcrumb mb-0" style={{ fontSize: '0.875rem' }}>
          {items.map((item, idx) => (
            <li
              key={idx}
              className={`breadcrumb-item${idx === items.length - 1 ? ' active' : ''}`}
              aria-current={idx === items.length - 1 ? 'page' : undefined}
            >
              {idx === items.length - 1 ? (
                <span>{item.name}</span>
              ) : (
                <Link to={item.url}>{item.name}</Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
